import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import {
  IonActionSheet,
  IonAlert,
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSearchbar,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { CameraSource } from "@capacitor/camera";

import "./UserChatWebComponent.scss";
import { UserChatService } from "../UserChat.service";
import { utilService } from "../../../services/utilService";
import Loader from "../../../components/Shared/Loader/Loader";
import { alertCircleSharp } from "ionicons/icons";
import {
  attachOutline,
  callOutline,
  camera,
  chevronBackOutline,
  chevronDownOutline,
  close,
  closeCircleOutline,
  ellipsisVertical,
  eyeOutline,
  imageOutline,
  informationCircleOutline,
  mic,
  navigateOutline,
  peopleOutline,
  personAddOutline,
  refreshOutline,
  sendOutline,
  trashOutline,
  videocam,
  videocamOutline,
  volumeHighOutline,
} from "ionicons/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import MessageListCard from "../../../components/Shared/MessageListCard/messageListCard";
import _, { divide } from "lodash";
import { setMessageListService } from "../../../components/Shared/MessageListCard/messageListCard.service";
import UserMessage from "../../UserMessages/UserMessage";
import { MessageHistoryService } from "../../../components/Shared/MessageListCard/MessageHistoryComponent/MessageHistory.service";
import FileShareMediaList from "../../FileShare/components/FileShareMediaList/FileShareMediaList";
import MediaUpload from "../../FileShare/components/MediaUpload/MediaUpload";
import SelectUserComponent from "../../FileShare/components/SelectUserComponent/SelectUserComponent";
import { dataTransferService } from "../../../services/dataTransferService";
import UserMessageListCard from "../UserMessageListCard/UserMessageListCard";
import MediaListCard from "../../FileShare/components/MediaListCard/MediaListCard";
import NoResults from "../../../components/Shared/NoResults/NoResultsComponent";
import Call from "../../../components/Shared/Call/call";
import { useToast } from "@agney/ir-toast";
import dayjs from "dayjs";
import { CONSTANTS } from "../../../constants";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import * as screenfull from "screenfull";
import { Screenfull } from "screenfull";
import { findDOMNode } from "react-dom";
import ReactPlayer from "react-player";
import { MediaUploadService } from "../../FileShare/components/MediaUpload/MediaUpload.service";
import { Popover, ArrowContainer } from "react-tiny-popover";
import { useFilePicker } from "use-file-picker";
import { usePhoto } from "../../../hooks/usePhoto";
import VideoComponent from "../../FileShare/components/VideoComponent/VideoComponent";
import { ImageService } from "../../FileShare/components/ImageComponent/ImageComponent.service";
import { AudioService } from "../../FileShare/components/AudioComponent/AudioComponent.service";
import { VideoService } from "../../FileShare/components/VideoComponent/VideoComponent.service";
import { userMessageService } from "../../UserMessages/UserMessage.service";
import { UserMessageCardComponent } from "../userMessage/UserMessageCardComponent";
import { MembersCard } from "../membersCard/MembersCard";
import { useHistory, useLocation } from "react-router-dom";
import AudioComponent from "../../FileShare/components/AudioComponent/AudioComponent";
import CallUser from "../../../components/Shared/Call/Components/CallUser/CallUser";
import { smsService } from "../../../components/Shared/Sms/Sms.service";
import { CallService } from "../../../components/Shared/Call/Call.service";
import RedCloseIcon from "../../../assets/icons/commonIcons/red-close-btn.png"
import DownArrowIcon from "../../../assets/icons/commonIcons/down-arrow.png"
import { NetworkListResponseModal } from "../../OnCallLookUp/OnCallLookUpModel";
import { OnCallLookUpInputService } from "../../OnCallLookUp/OnCalllookUpService";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { useChatWebSocket } from "../../../hooks/useChatSocket";
import { StorageService } from "../../../services";

const UserChatWebComponent: React.FC = (props: any) => {
  const history = useHistory();
  const location: any = useLocation();
  const { t } = useTranslation("messages");
  const [searchText, setSearchText] = useState("");
  const [messageListData, setMessageListData]: any = useState([]);
  const [showUrgentAlert, setShowUrgentAlert] = useState(false);
  const [messageNextValue, setMessageNextValue]: any = useState("");
  const [isShowPopOver, setShowPopover] = useState(false);
  const [isMessageLoaderActive, setIsMessageLoaderActive] = useState(false);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [selectedMessageCard, setSelectedMessageCard]: any = useState([]);
  const [showChatDeleteAlert, setShowChatDeleteAlert]: any = useState(false);
  const [showMessageDeleteAlert, setShowMessageDeleteAlert]: any =
    useState(false);
  const [isShowMsgDetails, setShowMsgDetails]: any = useState(true);
  const [isShowMediaDetails, setShowMediaDetails]: any = useState(false);
  const [isShowUserMsgComponent, setShowUserMsgComponent]: any =
    useState(false);
  const [isShowHistory, setShowHistory]: any = useState(false);
  const [userMessageData, setUserMessageData]: any = useState([]);
  const [isApiCalling, setIsApiCalling] = useState(false);
  const [smsHistoryData, setSmsHistoryData]: any = useState([]);
  const [incomingSmsHistoryData, setIncomingSmsHistoryData]: any = useState([]);
  const [historyPageNo, setHistoryPageNo]: [number, Function] = useState(1);
  const [smsHistoryNextValue, setSmsHistoryNextValue]: any = useState("");

  const [selectedGuid, setSelectedGuid]: any = useState([]);
  const [selectedUserName, setSelectedName]: any = useState([]);
  const [isShowMediaListModal, setIsShowMediaListModal] = useState(false);
  const [isShowUploadMediaModal, setIsShowUploadMediaModal] = useState(false);
  const [isShowSelectUserModal, setIsShowSelectUserModal] = useState(false);
  const [dataFromParentComponent, setDataFromParentComponent]: any = useState(
    []
  );
  const [fromUserGuid, setFromUserGuid]: any = useState();
  const [isForwardMessage, setForwardMessage]: any = useState(false);
  const [forwardMessageDetails, setForwardMessageDetails]: any = useState();
  const [selectedCardDetails, setSelectedCardDetails]: any = useState();
  const [messageList, setMessageList]: any = useState();

  const [isOpenMbrSpecialityContainer, setIsOpenMbrSpecialityContainer] =
    useState<boolean>(false);
  const [mbrSpecialityValues, setMbrSpecialityValues] = useState<any>([]);
  const [iOpenSlctMbrSpecialityContainer, setIsOpenSlctMbrSpecialityContainer] =
    useState<boolean>(false);
  const [slctMbrSpecialityValues, setSlctMbrSpecialityValues] = useState<any>(
    []
  );
  const [isN2nPermission, setisN2nPermission] = useState<any>(false);
  const [choosenNetwork, setChoosenNetwork] = useState<any>(null)
  const [selectedNetwork, setSelectedNetwork] = useState<any>(null)
  const [networkList, setNetworkList] = useState<any>([])
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState<boolean>(false)
    const [pageNumber, setPageNumber] = useState(1);
  const [chatList, setChatList] = useState<any>([]);
  const [selectedUserMsg, setSelectedUserMsg] = useState<any>(null);
  const selectedUserMsgRef = useRef<any>(null);
  const selectedNetworkRef = useRef<any>(null);
  const messageListFetchIdRef = useRef(0);
  const chatHistoryFetchIdRef = useRef(0);
  const messageListRefreshInFlightRef = useRef(false);
  const messageListRefreshPendingRef = useRef(false);
  const socketRefreshInFlightRef = useRef(false);
  const socketRefreshPendingRef = useRef(false);
  const lastSentListUpdateRef = useRef<{
    threadId: string;
    message: string;
    at: number;
  } | null>(null);
  const chatListRef = useRef<any[]>([]);

  useEffect(() => {
    selectedUserMsgRef.current = selectedUserMsg;
  }, [selectedUserMsg]);

  useEffect(() => {
    selectedNetworkRef.current = selectedNetwork;
  }, [selectedNetwork]);

  useEffect(() => {
    chatListRef.current = chatList;
  }, [chatList]);


  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setisN2nPermission(data?.userData?.n2nActivation)
    });

    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);




  const nextPage = "usermessages";
  const Toast = useToast();

  var [doctorInfoData, setDoctorInfoData]: any = useState([]);
  const [isShowCallModal, setIsShowCallModal] = useState(false);
  const [isShowCallUserModal, setIsShowCallUserModal] = useState(false);
  const [isPrimaryNumber, setIsPrimaryNumber] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isSecondaryNUmberExist, setIsSecondaryNumberExist] = useState(false);
  const [capabilityTokenInfo, setCapabilityTokenInfo] = useState("");
  const [networkSettings, setNetworkSettings] = useState<any>(null);
  

  const tokenValue =
    StorageService.getStorageItem(localStorage, "token") || "";
  

  useEffect(() => {
    if (doctorInfoData.userData && doctorInfoData.userData.alternateNumber) {
      setIsSecondaryNumberExist(true);
    } else {
      setIsSecondaryNumberExist(false);
    }
  }, [doctorInfoData]);

  async function fetchDoctorInfo(params: any) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result));
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists();
      }
    } else {
      smsService.handleErrorResponse();
    }
  }

  async function fetchAssignedContactInfo(params: any) {
    const respDoctorListResult: any =
      await smsService.getAssignedContactInformation(params);
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(_.cloneDeep(respDoctorListResult.result));
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists();
      }
    } else {
      smsService.handleErrorResponse();
    }
  }

  async function fetchCapabilityToken(params: any) {
    const respCapabilityTokenResult: any =
      await CallService.getCapabilityTokenInformation(params);
    if (respCapabilityTokenResult.isSuccess) {
      setCapabilityTokenInfo(respCapabilityTokenResult.result);
      setIsShowCallUserModal(true);
    } else {
      CallService.handleErrorResponse();
    }
  }

  const checkSecondaryNumberExists = () => {
    if (!_.isEmpty(props.dataFromPatientCard)) {
      setIsShowAlert(true);
    } else {
      if (!props.isAssignedNumber) {
        setIsShowCallModal(true);
      } else {
        setIsShowAlert(true);
      }
    }
  };



  const [selectedCallGuid, setSelectedCallGuid] = useState<any>(null);

  const paramsDoctorInfo = {
    guid: selectedCallGuid,
    reg_code: utilService.getNetwork(),
  };

  const fetchAllDataFromApi = (isAppToAppCall: boolean) => {
    if (!_.isEmpty(props.dataFromPatientCard)) {
      if (props.isPatient) {
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.patientDetails.contact_details[0]
                .number,
            firstName: props.dataFromPatientCard?.patientDetails.patient_name,
          },
        };
        setDoctorInfoData(doctorInfoData);
      } else if (props.isUnit) {
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.unit.contactDetails[0].number,
            firstName: props.dataFromPatientCard?.unit.unitName,
          },
        };
        setDoctorInfoData(doctorInfoData);
      } else if (props.isNurse) {
        if (!props.dataFromPatientCard?.nurseContactDetails?.guid) {
          Toast.error(t("noAssignedNurseAvailable"));
          return;
        }
        const doctorInfoData: any = {
          userData: {
            mobileNumber:
              props.dataFromPatientCard?.unit.contactDetails[0].number,
            firstName: props.dataFromPatientCard?.nurseContactDetails.name,
          },
        };
        setDoctorInfoData(doctorInfoData);
      }
    } else {
      if (props.isAssignedNumber) {
        if (!_.isEmpty(props.dataFromParent)) {
          const doctorInfoData: any = {
            userData: {
              mobileNumber: props.dataFromParent?.contactNumber,
              firstName: props.dataFromParent?.name,
            },
          };
          setDoctorInfoData(doctorInfoData);
        }
      }
    }

    paramsDoctorInfo.guid = isAppToAppCall ? paramsDoctorInfo.guid : "";
    fetchCapabilityToken(paramsDoctorInfo);
  };



  const initiateApiCall = (paramsDoctorInfo: any) => {
    if (
      !_.isEmpty(props.dataFromParent) ||
      !_.isEmpty(props.dataFromPatientCard)
    ) {
      setIsShowAlert(true);
    } else {
      props.isAssignedNumber
        ? fetchAssignedContactInfo(paramsDoctorInfo)
        : fetchDoctorInfo(paramsDoctorInfo);
    }
    if (props?.handleClose) {
      props?.handleClose();
    }
  };

  useEffect(() => {
    if (!_.isEmpty(location.state)) {
      const formatedData = location?.state?.selectedDoctorData?.map(
        (doctor: any) => {
          return {
            ...doctor,
            first_name: doctor?.firstName,
            last_name: doctor?.lastName,
            profile_pic: doctor?.profilePic?.replace(
              utilService.getBaseUrl(),
              ""
            ),
          };
        }
      );
      const params = location?.state?.clickedMessage
        ? location?.state?.clickedMessage
        : {
          thread_users: formatedData,
          sms_thread_id: location?.state?.smsThreadId ?? "",
          is_group_sms: formatedData?.length > 1,
          thread_avatar:
            formatedData?.length > 1
              ? ""
              : formatedData[0]?.profilePic?.replace(
                utilService.getBaseUrl(),
                ""
              ),
        };
      handleMessageClick(params, formatedData?.length > 1 ? "2" : "1", location?.state?.n2nNetwork);
      if (location?.state?.n2nNetwork) {
        setChoosenNetwork(location?.state?.n2nNetwork)
        setSelectedNetwork(location?.state?.n2nNetwork)
      }
      setSelectedUserMsg(params);
    }
  }, [location]);

  useEffect(() => {
    getNetworkList();
    fetchMessageDetails(1, selectedNetwork);
  }, []);

  useEffect(() => {
    setPageNo(1);
  }, [searchText, selectedNetwork]);

  useEffect(() => {
    if (incomingSmsHistoryData) {
      setMessageList(incomingSmsHistoryData);
    }
  }, [incomingSmsHistoryData]);




  useEffect(() => {
    if (!_.isEmpty(messageListData)) {
      handleMessageCardSelection(messageListData[0]);
    }
  }, [messageListData]);

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const matchesThreadId = (threadIdA: any, threadIdB: any) =>
    threadIdA != null &&
    threadIdB != null &&
    String(threadIdA) === String(threadIdB);

  const getLatestChatMessage = (messages: any[]) => {
    if (!messages?.length) return null;

    return messages.reduce((latest: any, current: any) => {
      if (!latest) return current;

      const latestTime = new Date(latest.created_on).getTime();
      const currentTime = new Date(current.created_on).getTime();
      return currentTime >= latestTime ? current : latest;
    }, null);
  };

  const syncListPreviewFromChat = (threadId: any, chatMessages: any[]) => {
    if (!threadId || !chatMessages?.length) return;

    const latestMessage = getLatestChatMessage(chatMessages);
    if (!latestMessage) return;

    const previewText = latestMessage.message_text ?? "";
    const hasMedia = !!latestMessage.message_has_media;
    const latestMedia = Array.isArray(latestMessage?.media_data) && latestMessage.media_data.length > 0 ? latestMessage.media_data[0] : null;
    const mediaType = latestMedia?.media_type;

    setMessageListData((prev: any[]) => {
      const threadIndex = prev.findIndex((item) =>
        matchesThreadId(item.sms_thread_id, threadId)
      );
      if (threadIndex === -1) return prev;

      const updatedThread = {
        ...prev[threadIndex],
        recent_message: previewText,
        recent_message_has_media: hasMedia,
        ...(hasMedia && mediaType
          ? { recent_message_type: mediaType }
          : {}),
        created_on: latestMessage.created_on,
        is_last_message_seen: true,
        unread_message_count: 0,
      };

      const nextList = [...prev];
      nextList.splice(threadIndex, 1);
      return [updatedThread, ...nextList];
    });
  };

  const mergeActiveThreadPreviewFromChat = (listData: any[]) => {
    const activeThread = selectedUserMsgRef.current;
    if (!activeThread?.sms_thread_id || !chatListRef.current?.length) {
      return listData;
    }

    const latestMessage = getLatestChatMessage(chatListRef.current);
    if (!latestMessage) return listData;

    const threadIndex = listData.findIndex((item) =>
      matchesThreadId(item.sms_thread_id, activeThread.sms_thread_id)
    );
    if (threadIndex === -1) return listData;

    const serverThread = listData[threadIndex];
    const chatTime = new Date(latestMessage.created_on).getTime();
    const serverTime = new Date(serverThread.created_on).getTime();
    const previewText = latestMessage.message_text ?? "";

    if (
      chatTime < serverTime &&
      serverThread.recent_message === previewText
    ) {
      return listData;
    }

    const latestMedia = Array.isArray(latestMessage?.media_data) && latestMessage.media_data.length > 0 ? latestMessage.media_data[0] : null;

    const updatedThread = {
      ...serverThread,
      recent_message: previewText,
      recent_message_has_media: !!latestMessage.message_has_media,
      ...(latestMessage.message_has_media && latestMedia?.media_type
        ? { recent_message_type: latestMedia.media_type }
        : {}),
      created_on: latestMessage.created_on,
      is_last_message_seen: true,
      unread_message_count: 0,
    };

    const nextList = [...listData];
    nextList.splice(threadIndex, 1);
    return [updatedThread, ...nextList];
  };

  const optimisticallyUpdateThreadInList = (
    threadId: string,
    sentText: string,
    hasMedia: boolean,
    mediaType?: number
  ) => {
    if (!threadId) return;

    const mediaTypeLabel =
      mediaType === CONSTANTS.MEDIA_TYPE.IMAGE
        ? "Image"
        : mediaType === CONSTANTS.MEDIA_TYPE.VIDEO
          ? "Video"
          : mediaType === CONSTANTS.MEDIA_TYPE.AUDIO
            ? "Audio"
            : undefined;

    setMessageListData((prev: any[]) => {
      const threadIndex = prev.findIndex((item) =>
        matchesThreadId(item.sms_thread_id, threadId)
      );
      if (threadIndex === -1) return prev;

      const updatedThread = {
        ...prev[threadIndex],
        recent_message: hasMedia ? prev[threadIndex].recent_message : sentText,
        recent_message_has_media: hasMedia,
        ...(hasMedia && mediaTypeLabel
          ? { recent_message_type: mediaTypeLabel }
          : {}),
        created_on: new Date().toISOString().replace(/\.\d{3}Z$/, ""),
        is_last_message_seen: true,
        unread_message_count: 0,
      };

      const nextList = [...prev];
      nextList.splice(threadIndex, 1);
      return [updatedThread, ...nextList];
    });

    if (!hasMedia && sentText) {
      lastSentListUpdateRef.current = {
        threadId,
        message: sentText,
        at: Date.now(),
      };
    }
  };

  const reconcileListWithRecentSend = (listData: any[]) => {
    const lastSent = lastSentListUpdateRef.current;
    if (!lastSent || Date.now() - lastSent.at > 10000) {
      return listData;
    }

    const threadIndex = listData.findIndex((item) =>
      matchesThreadId(item.sms_thread_id, lastSent.threadId)
    );

    if (threadIndex === -1) {
      return listData;
    }

    const serverThread = listData[threadIndex];
    if (serverThread.recent_message === lastSent.message) {
      lastSentListUpdateRef.current = null;
      return listData;
    }

    const reconciledThread = {
      ...serverThread,
      recent_message: lastSent.message,
      recent_message_has_media: false,
      created_on: new Date().toISOString().replace(/\.\d{3}Z$/, ""),
      is_last_message_seen: true,
      unread_message_count: 0,
    };

    const nextList = [...listData];
    nextList.splice(threadIndex, 1);
    return [reconciledThread, ...nextList];
  };

  async function fetchMessageDetails(page: number = 1, n2nNetwork?: string, searchTextParms?: string) {
    const fetchId = ++messageListFetchIdRef.current;
    const params = {
      timezone,
      searchQuery: searchTextParms ? searchTextParms : searchText,
      pageNumber: page,
      n2nNetwork: n2nNetwork ?? ""
    };

    if (page === 1) {
      setIsMessageLoaderActive(true);
    }

    const respMessageListResult: any = await UserChatService.getMessageListData(
      params
    );

    if (fetchId !== messageListFetchIdRef.current) {
      return respMessageListResult;
    }

    if (respMessageListResult?.isSuccess) {
      let newData = respMessageListResult?.result?.[0]?.data || [];

      if (page === 1) {
        newData = reconcileListWithRecentSend(newData);
        newData = mergeActiveThreadPreviewFromChat(newData);
        setMessageListData(newData);
        if (newData.length > 0 && !selectedUserMsgRef.current && !location?.state?.clickedMessage) {
          const firstItem = newData[0];
          handleMessageCardSelection(firstItem);
          handleMessageClick(
            firstItem,
            firstItem?.is_group_sms ? 2 : 1,
            firstItem?.message_settings?.thread_users_network?.toString()
          );
        }
      } else if (newData.length > 0) {
        setMessageListData((prev: any) => [...prev, ...newData]);
      }
    } else {
      Toast.error(respMessageListResult?.message);
    }
    setMessageNextValue(respMessageListResult?.result?.[0]?.next);
    setIsMessageLoaderActive(false);
    return respMessageListResult;
  }

  const refreshMessageList = async (n2nNetwork?: string) => {
    const network = n2nNetwork ?? selectedNetworkRef.current;

    if (messageListRefreshInFlightRef.current) {
      messageListRefreshPendingRef.current = true;
      return;
    }

    messageListRefreshInFlightRef.current = true;
    try {
      do {
        messageListRefreshPendingRef.current = false;
        await fetchMessageDetails(1, network);
      } while (messageListRefreshPendingRef.current);
    } finally {
      messageListRefreshInFlightRef.current = false;
    }
  };

  const handleSocketRefresh = async () => {
    if (socketRefreshInFlightRef.current) {
      socketRefreshPendingRef.current = true;
      return;
    }

    socketRefreshInFlightRef.current = true;
    try {
      do {
        socketRefreshPendingRef.current = false;

        const currentThread = selectedUserMsgRef.current;
        if (currentThread?.sms_thread_id) {
          const n2nNetwork =
            currentThread?.message_settings?.thread_users_network?.toString() ??
            selectedNetworkRef.current ??
            "";

          await refreshActiveChat(currentThread, n2nNetwork);
        }

        await refreshMessageList();
      } while (socketRefreshPendingRef.current);
    } finally {
      socketRefreshInFlightRef.current = false;
    }
  };

  useLayoutEffect(() => {
    let sub = dataTransferService.getReplyMediaAction.subscribe((data: any) => {
      if (!_.isEmpty(data)) {
        setIsShowMediaListModal(false);
        setIsShowSelectUserModal(false);
        setIsShowUploadMediaModal(true);
        setDataFromParentComponent(data);
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getForwardMediaAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          setIsShowMediaListModal(false);
          setIsShowUploadMediaModal(false);
          setIsShowSelectUserModal(true);
          setDataFromParentComponent(data);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const setMessageListParams = (searchedText: string, page: number = 1) => {
    return {
      search_text: searchedText,
      page: page,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };

  const onScroll = () => {
    if (!_.isEmpty(messageListData) && messageNextValue) {
      const nextPage = pageNo + 1;
      setPageNo(nextPage);
      fetchMessageDetails(nextPage, selectedNetwork);
    }
  };
  const [chatListNextPage, setChatListNextPage] = useState(null);
  const [chatListCount, setChatChatListCount] = useState(0);

  const onChatListScroll = () => {
    if (!_.isEmpty(chatList) && chatListNextPage) {
      setPageNumber(pageNumber + 1);
      handleMessageClick(
        selectedUserMsg,
        selectedUserMsg?.thread_users > 1 ? "2" : "1",
        networkSettings?.thread_users_network?.toString() ?? "",
        pageNumber + 1,
      );
    }
  };

  const refreshSelectedMessage = () => {
    setNonMultiSelectedCardList(selectedCardDetails);
  };

  const handleMessageCardSelection = (selectedCard: any) => {
    setSelectedCardDetails(selectedCard);
    setNonMultiSelectedCardList(selectedCard);
    setShowMsgDetails(true);
    setShowUserMsgComponent(false);
    setShowHistory(false);
    setForwardMessage(false);
    resetSmsHistoryValues();
    setForwardMessage(false);
    setIsShowMediaListModal(true);
    setIsShowUploadMediaModal(false);
    setIsShowUploadMediaModal(false);
    updateListCard(selectedCard);
  };

  const updateListCard = (selectedCard: any) => {
    let data = messageListData;
    let selectedSite: any = messageListData.findIndex(
      (selectedMsgData: any) => selectedMsgData.id === selectedCard.id
    );
    if (selectedSite !== 0) {
      const updatedMsgList = (data[selectedSite].is_seen = true);
      setMessageListData(data);
    } else if (selectedSite === 0) {
      const updatedMsgList = (data[selectedSite].is_seen = true);
      setMessageListData(data);
    }
  };

  const setNonMultiSelectedCardList = (card: any) => {
    const selectedMessageCardList: Array<any> = [];
    messageListData.map((item: any) => {
      if (card.id === item.id) {
        item.isSelected = true;
        selectedMessageCardList.push(card);
      } else {
        item.isSelected = false;
      }
    });
    setSelectedMessageCard(_.cloneDeep(selectedMessageCardList));
    if (selectedMessageCard.length !== 0) {
      // getIncomingMessageHistory(selectedMessageCardList);
    }
  };

  // const handleDeleteMessage = async () => {
  //   const params = getDeleteMessagesApiParams();
  //   const apiResponse: any = await setMessageListService.removeMessageListItem(
  //     params
  //   );
  //   if (apiResponse.isSuccess) {
  //     fetchMessageDetails();
  //     Toast.success("Message deleted successfully");
  //     setMessageList([]);
  //   } else {
  //     Toast.error(apiResponse?.message);
  //   }
  // };

  const updateMessageList = () => {
    refreshMessageList(selectedNetwork);
  };

  const handleUserMessageOnCancel = () => {
    // setIsLoaderActive(true);
    setIncomingSmsHistoryData([]);
    setMessageList([]);
    setShowMsgDetails(true);
    setShowUserMsgComponent(false);
    setShowHistory(false);
    resetSmsHistoryValues();
    setForwardMessage(false);
    setNonMultiSelectedCardList(selectedCardDetails);
    updateListCard(selectedCardDetails);
    fetchMessageDetails(1, selectedNetwork);
    // handleRefresh()
  };

  const getIncomingSmsHistoryParams = (messageCard: any, page: number) => {
    var params = {
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      sms_thread_id: messageCard[0].sms_thread_id,
      page: page,
    };
    return params;
  };

  const getIncomingMessageHistory = async (
    messageCard: any,
    page: number = 1
  ) => {
    if (page === 1) {
      setIsApiCalling(true);
    }
    setIsLoaderActive(true);
    const params: any = getIncomingSmsHistoryParams(messageCard, page);
    const respSmsHistoryResult: any =
      await MessageHistoryService.getIncomingMessageHistoryDetails(params);
    if (respSmsHistoryResult.isSuccess && respSmsHistoryResult.result?.[0]) {
      // setSmsHistoryNextValue(respSmsHistoryResult.result?.[0]?.next);

      let fromUserDetails = respSmsHistoryResult.result?.[0]?.data;
      if (page === 1) {
        setIncomingSmsHistoryData(
          _.cloneDeep(respSmsHistoryResult.result?.[0]?.data)
        );
      } else {
        setIncomingSmsHistoryData([
          ...incomingSmsHistoryData,
          ...respSmsHistoryResult.result?.[0]?.data,
        ]);
      }

      if (fromUserDetails) {
        fromUserDetails.filter((item: any) => {
          if (item.request_type === "received") {
            setFromUserGuid(item.from_user.guid);
          }
        });
      }
      setIsLoaderActive(false);
    } else {
      setIsLoaderActive(false);
    }
    setIsLoaderActive(false);
    setIsApiCalling(false);
  };


  const resetSmsHistoryValues = () => {
    setSmsHistoryData(_.cloneDeep([]));
    setSmsHistoryNextValue("");
    setHistoryPageNo(1);
  };

  const getSmsHistoryParams = (page: number) => {
    var params = {
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      sms_thread_id: selectedMessageCard[0].sms_thread_id,
      page: page,
    };
    return params;
  };

  const updateForwardMessage = (forwardMsgDetails: any) => {
    setForwardMessageDetails(forwardMsgDetails);
    setShowMsgDetails(false);
    setShowUserMsgComponent(false);
    setShowHistory(false);
    setShowMediaDetails(false);
    setForwardMessage(true);
  };



  const handleMessageSeen = (threadID: any, n2nNetwork?: string) => {
    const params = {
      reg_code: utilService.getNetwork(),
      is_seen: true,
      sms_thread_id: threadID,
      n2n_network: n2nNetwork ?? ""
    };
    const apiResponse: any =
      setMessageListService.updateMessageReadStatus(params);
    if (apiResponse) {
      setMessageListData(
        messageListData?.map((message: any) => {
          if (message?.sms_thread_id === threadID) {
            return {
              ...message,
              is_last_message_seen: true,
              unread_message_count: 0,
            };
          } else {
            return message;
          }
        })
      );
    }
  };

  const handleMessageClick = async (data: any, chatType: any, n2nNetwork?: string, page?: any) => {
    setSelectedUserMsg(data);
    setChatList([]);
    setMessage("")
    handleRemoveAttachments()
    setIsLoaderActive(true);

    const threadUsers = data?.thread_users?.map((user: any) => user?.guid);
    const payload = {
      smsThreadId: data?.sms_thread_id,
      guids: threadUsers?.join(","),
      chatType: chatType,
      timezone: timezone,
      page: page ? page : pageNumber,
      n2nNetwork: n2nNetwork ?? ""
    };
    const respMessageListResult: any = await UserChatService.fetchChatHistory(
      payload
    );
    setNetworkSettings(respMessageListResult?.result?.[0]?.message_settings)
    if (!data?.is_last_message_seen) {
      handleMessageSeen(data?.sms_thread_id, n2nNetwork);
    }
    setChatListNextPage(respMessageListResult?.result?.[0]?.next);
    setChatChatListCount(respMessageListResult?.result?.[0]?.count);
    setChatList(respMessageListResult?.result?.[0]?.data);
    setIsLoaderActive(false);
  };

  const refreshActiveChat = async (thread: any, n2nNetwork?: string) => {
    if (!thread?.sms_thread_id) return;

    const fetchId = ++chatHistoryFetchIdRef.current;
    const threadUsers = thread?.thread_users?.map((user: any) => user?.guid);
    const payload = {
      smsThreadId: thread.sms_thread_id,
      guids: threadUsers?.join(","),
      chatType: thread?.is_group_sms ? 2 : 1,
      timezone,
      page: 1,
      n2nNetwork: n2nNetwork ?? "",
    };

    const respMessageListResult: any =
      await UserChatService.fetchChatHistory(payload);

    if (fetchId !== chatHistoryFetchIdRef.current) return;

    if (respMessageListResult?.result?.[0]) {
      const chatData = respMessageListResult.result?.[0]?.data ?? [];
      chatListRef.current = chatData;
      setNetworkSettings(respMessageListResult.result?.[0]?.message_settings);
      setChatListNextPage(respMessageListResult.result?.[0]?.next);
      setChatChatListCount(respMessageListResult.result?.[0]?.count);
      setChatList(chatData);
      syncListPreviewFromChat(thread.sms_thread_id, chatData);
      handleMessageSeen(thread.sms_thread_id, n2nNetwork);
    }
  };

  useChatWebSocket({
    token: tokenValue,
    smsThreadId: selectedUserMsg?.sms_thread_id,
    onRefresh: async () => {
      await handleSocketRefresh();
    },
  });

  const [message, setMessage] = useState("");
  const textareaRef: any = useRef(null);
  const attachmentBtnRef = useRef<any>(null);
  const [isShowNewPopOver, setShowNewPopover] = useState(false);
  const [isCaptureMediaPopOver, setIsCaptureMediaPopOver] = useState(false);
  const [isAudioActionSheetOpen, setIsAudioActionSheetOpen] =
    useState<boolean>(false);
  const [isVideoActionSheetOpen, setIsVideoActionSheetOpen] =
    useState<boolean>(false);
  const [isImageActionSheetOpen, setIsImageActionSheetOpen] =
    useState<boolean>(false);
  const attachVideoInputRef: any = useRef();
  const [mediaType, setMediaType]: any = useState();
  const [isVideoRecording, setIsVideoRecording] = useState(false);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [isMediaAttach, setMediaAttach] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isOpenAttachmentActionPopover, setIsOpenAttachmentActionPopover] =
    useState(false);
  const [isSelectUserModalOpen, setIsSelectUserModalOpen] = useState(false);
  const [isSendActionPopoverOpen, setIsSendActionPopoverOpen] = useState(false);
  const [isVideoDeviceAvailable, setIsVideoDeviceAvailable] = useState(true);
  const [isAudioDeviceAvailable, setIsAudioDeviceAvailable] = useState(true);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [displayMediaList, setDisplayMediaList]: any = useState([]);
  var [showLoader, setShowLoader] = useState(false);

  const setVideoAndAudioDeviceStatus = () => {
    var localVideoStream: any;
    var localAudioStream: any;
    navigator.mediaDevices.getUserMedia({ video: true }).then(
      function (stream) {
        setIsVideoDeviceAvailable(true);
        localVideoStream = stream;
        stream.getTracks().forEach((track) => track.stop());
      },
      function () {
        setIsVideoDeviceAvailable(false);
      }
    );

    if (localVideoStream) {
      localVideoStream.getTracks().forEach((track: any) => track.stop());
    }

    navigator.mediaDevices.getUserMedia({ audio: true }).then(
      function (stream) {
        setIsAudioDeviceAvailable(true);
        localAudioStream = stream;
        stream.getTracks().forEach((track) => track.stop());
      },
      function () {
        setIsAudioDeviceAvailable(false);
      }
    );

    if (localAudioStream) {
      localAudioStream.getTracks().forEach((track: any) => track.stop());
    }
  };

  useEffect(() => {
    if (utilService.isWeb() && showVideoUploadModal) {
      setVideoAndAudioDeviceStatus();
    }
  }, [showVideoUploadModal]);

  const [openFileSelector, { plainFiles }] = useFilePicker({
    accept: ".mp3,.wav,audio/",
  });

  useEffect(() => {
    if (!_.isEmpty(plainFiles)) {
      const fileCollection: any = plainFiles;
      for (var index = 0; index < fileCollection.length; index++) {
        const fileData = fileCollection[index];
        const clientMediaID = Math.floor(Math.random() * 10000);
        fileData["clientMediaID"] = clientMediaID;
        setNativeTemp(fileData, 2);
      }
      setShowPopover(false);
      setMediaAttach(true);
    }
  }, [plainFiles]);

  const { takePhoto, photos } = usePhoto();

  useEffect(() => {
    setProfilePicture();
  }, [photos]);

  const dataURLtoFile = (dataUrl: any, filename: any) => {
    var dataArray = dataUrl.split(","),
      mime = dataArray[0].match(/:(.*?);/)[1],
      bstr = atob(dataArray[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const setProfilePicture = () => {
    var initValueBase = props.initValue == null ? "" : props.initValue;
    var bSixtyFour = photos !== undefined ? photos.base64 : initValueBase;
    let imageFileName =
      "IMG-" + new Date().getMinutes() + new Date().getSeconds();
    if (!_.isEmpty(bSixtyFour)) {
      let imageFile: any = dataURLtoFile(bSixtyFour, imageFileName);
      setNativeTemp(imageFile, 1);
      setMediaAttach(true);
    }
    setIsOpenAttachmentActionPopover(false)
  };

  const setMediaList = () => {
    setDisableSendButton(false);
    const mediaList = [
      ...ImageService.displayImageList,
      ...AudioService.displayAudioList,
      ...VideoService.displayVideoList,
    ];
    setDisplayMediaList(_.cloneDeep([...mediaList]));
  };

  const onComplete = (mediaType: Number) => {
    setMediaList();
    closeModalPopUp(mediaType);
  };

  const closeModalPopUp = (type: Number) => {
    setShowVideoUploadModal(false);
  };

  const showRecordForMedia = (recordDiv: any, status: any) => {
    recordDiv.classNameList.add("notRec");
    if (status) {
      recordDiv.classNameList.add("Rec");
    } else {
      recordDiv.classNameList.add("notRec");
      recordDiv.classNameList.remove("Rec");
    }
  };

  const setAudioRecordCss = (status: Boolean) => {
    const recDiv: any = document.getElementById("recButton");
    // showRecordForMedia(recDiv, status);
  };

  const [disableMediaSection, setDisableMediaSection] = useState(false);
  const [timerIntervalID, setTimerIntervalID]: any = useState("");

  const stopTimerInUI = () => {
    const minute: any = document.querySelector(".mins");
    const seconds: any = document.querySelector(".sec");
    if (minute) minute.innerHTML = "00";
    if (seconds) seconds.innerHTML = "00";
    clearInterval(timerIntervalID);
  };

  const showTimerinUI = (minute: any, seconds: any) => {
    const startTime: any = new Date();
    let duration = 0;
    let stopTime = 0;
    const timer: any = setInterval(() => {
      let currTime: any = new Date();
      duration = stopTime + (currTime - startTime) / 1000;
      const mins = Math.floor(duration / 60);
      const secs = Math.floor(duration % 60);
      if (minute) minute.innerHTML = mins < 10 ? `0${mins}` : `${mins}`;
      if (seconds) seconds.innerHTML = secs < 10 ? `0${secs}` : `${secs}`;
    }, 200);

    setTimerIntervalID(timer);
  };

  const startAudioTimer = () => {
    const minsEle: any = document.querySelector(".mins");
    const secEle: any = document.querySelector(".sec");
    showTimerinUI(minsEle, secEle);
  };

  const onAudioRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.AUDIO);
    if (utilService.isWeb()) {
      setIsRecording(!isRecording);
      setAudioRecordCss(!isRecording);
      setDisableMediaSection(!isRecording);
      if (!isRecording) {
        startAudioTimer();
        setMediaAttach(true);
      }
      if (isRecording) {
        stopTimerInUI();
      }
    }
    dataTransferService.transferAudioMediaAction(!isRecording);
  };

  const handleInput = (e: any) => {
    setMessage(e.target.value);
    textareaRef.current.style.height = "3rem";
    textareaRef.current.style.height = `${Math.min(
      textareaRef.current.scrollHeight,
      80
    )}px`;
  };

  const handleSendUrgentMessage = (message: any) => {
    setShowUrgentAlert(true);
  };

  const [player, setPlayer]: any = useState({});
  const [isAttachmentListPopoverVisibile, setIsAttachmentListPopoverVisibile] =
    useState<boolean>(false);
  const [membersInfoListPopoverOpen, setMembersInfoListPopoverOpen] =
    useState<boolean>(false);
  const [selectedReplyMessage, setSelectedReplyMessage] = useState<any>(null);
  const [selectedforwardMessage, setSelectedForwardMessage] =
    useState<any>(null);

  const viewItem = (type: string, id: Number) => {
    switch (type) {
      case "Audio":
        // playAudio();
        break;
      case "Video":
        viewVideo();
        break;
      case "Image":
        viewWebImage(id);
        break;
    }
  };

  const viewWebImage = (id: Number) => {
    const img: any = document.getElementById(`media-${id}`);
    const viewer = new Viewer(img, {
      backdrop: true,
      button: false,
      toolbar: 0,
      hide() {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  const viewVideo = () => {
    (screenfull as Screenfull).request(findDOMNode(player) as any);
  };

  useEffect(() => {
    if (
      messageListData?.length > 0 &&
      _.isEmpty(location.state) &&
      _.isEmpty(selectedUserMsg)
    ) {
      setSelectedUserMsg(messageListData[0]);
      handleMessageClick(
        messageListData[0],
        messageListData[0]?.is_group_sms ? 2 : 1,
        messageListData[0]?.message_settings?.thread_users_network?.toString() ?? ""
      );
    }
  }, [messageListData, location]);
  // }, [messageListData, location]);

  const handleClear = () => {
    textareaRef.current.style.height = "3rem";
    setMessage("");
    handleCloseRplyMsg();
    setSelectedUsers([]);
    setModalInpuValue("");
    setIsSendActionPopoverOpen(false);
    setDisplayMediaList([]);
    ImageService.displayImageList = [];
    AudioService.displayAudioList = [];
    VideoService.displayVideoList = [];
    setIsSelectUserModalOpen(false);
    if (location?.state?.isMultiSendEnabled) {
      history.goBack()
    }
  };

  const sendMessage = async (
    guids: any,
    type: any,
    action: any,
    chatType: any,
    sentToAll: any,
    fileData: any,
    userIDs?: any,
    isUrgent: boolean = false // 👈 add this
  ) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const params: any = {
      clientMediaID: clientMediaID,
      from_guid: [utilService.getLoggedUserGuid()],
      to_guid: JSON.stringify(
        guids?.filter((guid: any) => guid !== utilService.getLoggedUserGuid())
      ),
      message: message,
      type: type,
      action: action,
      name: fileData?.name?.replace(/\s+/g, '') ?? "",
      sms_thread_id: chatList[0]?.sms_thread_id ?? "",
      file: fileData?.file ?? "",
      size: fileData?.size ?? "",
      id: selectedReplyMessage?.id ?? "",
      is_quoted_reply: !!selectedReplyMessage,
      quoted_message_id: selectedReplyMessage?.id ?? "",
      is_group_sms: chatType === "2",
      send_to_all: sentToAll,
      reg_code: utilService.getNetwork(),
      pid: location?.state?.pid ?? "",
      unit_id: location?.state?.unit_id ?? "",
    };

    if (isUrgent) {
      params.type = "critical";
      params.bypass_dnd = true;
    }
    const formData = utilService.constructFormData(params);
    const respFileShareMediaListResult: any =
      await MediaUploadService.mediaUpload(formData);
    if (respFileShareMediaListResult?.isSuccess) {
      const sentText = message;
      const hasMedia = displayMediaList?.length > 0;
      const sentMediaType = displayMediaList?.[0]?.type;
      const threadId =
        selectedUserMsg?.sms_thread_id ??
        selectedUserMsgRef.current?.sms_thread_id ??
        chatList[0]?.sms_thread_id ??
        "";
      const currentThread = selectedUserMsgRef.current ?? selectedUserMsg;
      const n2nNetwork =
        networkSettings?.thread_users_network?.toString() ??
        selectedNetworkRef.current ??
        "";

      optimisticallyUpdateThreadInList(
        threadId,
        sentText,
        hasMedia,
        sentMediaType
      );
      handleClear();
      await refreshActiveChat(currentThread, n2nNetwork);
    }
  };

  const [isMessageSentLoader, setIsMessageSentLoader] =
    useState<boolean>(false);

  const handleSendMessage = async (isSentAll: boolean, isUrgent = false) => {
    setIsMessageSentLoader(true);
    const guids =
      selectedUsers?.length > 0
        ? selectedUsers?.map((user: any) => user?.guid)
        : selectedUserMsg?.thread_users?.map((user: any) => user?.guid);
    const userIds = selectedUsers?.length > 0
      ? selectedUsers?.map((user: any) => user?.id)
      : selectedUserMsg?.thread_users?.map((user: any) => user?.id);
    if (displayMediaList?.length > 0) {
      displayMediaList?.forEach(async (file: any, index: number) => {
        await sendMessage(
          guids,
          file?.type,
          selectedReplyMessage ? "4" : "1",
          selectedUserMsg?.thread_users?.length > 1 &&
            !location?.state?.isMultiSendEnabled
            ? "2"
            : "1",
          isSentAll,
          file,
          userIds ?? "",
          isUrgent
        );
        if (index === displayMediaList?.length - 1) {
          setIsMessageSentLoader(false);
        }
      });
    } else {
      await sendMessage(
        guids,
        "4",
        selectedReplyMessage ? "4" : "1",
        selectedUserMsg?.thread_users?.length > 1 &&
          !location?.state?.isMultiSendEnabled
          ? "2"
          : "1",
        isSentAll,
        {},
        userIds ?? "",
        isUrgent
      );
      setIsMessageSentLoader(false);
    }
  };

  const openModalPopUp = (type: Number) => {
    setMediaType(type);
    setIsVideoRecording(false);
    setShowVideoUploadModal(true);
    setMediaAttach(true);
  };

  const convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });

  const storeToDisplayService = (sanitizedUrl: any, mediaType: any) => {
    if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      ImageService.displayImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      AudioService.displayAudioList.push(sanitizedUrl);
    } else {
      VideoService.displayVideoList.push(sanitizedUrl);
    }
    setMediaList();
  };

  const setNativeTemp = async (file: any, mediaType: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const base64Data = (await convertBlobToBase64(file)) as string;
    const params = {
      name: file.name,
      nativeURL: base64Data,
      type: mediaType,
      isNative: false,
      clientMediaID,
      size: utilService.formatBytes(file.size),
      isAttach: true,
      file,
    };
    storeToDisplayService(params, mediaType);
  };

  const webAttachMedia = (mediaType: any) => {
    let file: any = "";
    if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      file = document.getElementsByName("audio-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      file = document.getElementsByName("image-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.VIDEO) {
      file = document.getElementsByName("video-file")[0] as any;
    }
    const fileCollection: any = file.files;
    for (var index = 0; index < fileCollection.length; index++) {
      const fileData = fileCollection[index];
      const clientMediaID = Math.floor(Math.random() * 10000);
      // setClientMediaID(clientMediaID);
      fileData["clientMediaID"] = clientMediaID;
      setNativeTemp(fileData, mediaType);
    }
    // setShowPopover(false);
    setMediaAttach(true);
  };

  const handleRefresh = () => {
    handleMessageClick(selectedUserMsg, selectedUserMsg?.is_group_sms ? 2 : 1, networkSettings?.thread_users_network?.toString() ?? "");
  };

  const handleDeleteAction = async (type: any, ids: any) => {
    const payload = {
      smsThreadId: chatList[0]?.sms_thread_id,
      ids: ids ?? "",
      type,
      n2nNetwork: networkSettings?.thread_users_network?.toString() ?? ""
    };
    const response = await UserChatService.deleteChat(payload);
    if (type === 2) {
      fetchMessageDetails(1, selectedNetwork);
      setSelectedUserMsg(null);
      if (location?.state?.isFullscreen) {
        history.goBack();
      }
    } else {
      fetchMessageDetails(1, selectedNetwork);
      if (chatList?.length === 1) {
        // setting selected user msg to null
        setSelectedUserMsg(null);
      } else {
        handleMessageClick(selectedUserMsg, selectedUserMsg?.is_group_sms ? 2 : 1, networkSettings?.thread_users_network?.toString() ?? "")
      }


    }
  };

  const handleForward = (message: any) => {
    setSelectedForwardMessage(message);
    setForwardMessage(true);
  };

  const handleReply = (message: any) => {
    if (textareaRef.current) {
      textareaRef.current.focus(); // Focus the textarea
    }
    // setSelectedUserMsg(message)
    setSelectedReplyMessage(message);
  };

  const handleCloseRplyMsg = () => {
    setSelectedReplyMessage(null);
  };

  const handleAddMembers = () => {
    history.push({
      pathname: "/client/file-share/selectuser",
      state: {
        isFromNewChat: true,
        isAddMember: true,
        selectedUserMsg: selectedUserMsg,
        n2nNetwork: networkSettings?.thread_users_network?.toString() ?? "",
        isNetworkSelectionDisabled: true
      },
    });
  };

  const [deleteMessageItem, setDeleteMessageItem] = useState<any>(null);

  const handleDeleteMessage = (message: any) => {
    setShowMessageDeleteAlert(true);
    setDeleteMessageItem(message);
  };

  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [threadUsers, setThreadUsers] = useState<any>([]);
  const [modalInpuValue, setModalInpuValue] = useState<any>("");
  const [isAudioModalOpen, setIsAudioModalOpen] = useState<boolean>(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    if (selectedUserMsg) {
      setThreadUsers(selectedUserMsg?.thread_users);
    }
  }, [selectedUserMsg]);

  const handleGrpUserSelect = (member: any) => {
    if (
      selectedUsers.find(
        (selectedUser: any) => selectedUser?.guid === member?.guid
      )
    ) {
      setSelectedUsers(
        selectedUsers?.filter(
          (selectedUser: any) => selectedUser?.guid !== member?.guid
        )
      );
    } else {
      setSelectedUsers([...selectedUsers, member]);
    }
  };

  const handleModalInputChange = (e: any) => {
    setModalInpuValue(e?.target?.value);
    setThreadUsers(
      selectedUserMsg?.thread_users?.filter((user: any) =>
        `${user.first_name} ${user.last_name}`
          .toLowerCase()
          .includes(e?.target?.value.toLowerCase())
      )
    );
  };

  const handleModalCancel = () => {
    setIsSelectUserModalOpen(false);
    setModalInpuValue("");
    setThreadUsers(selectedUserMsg?.thread_users);
  };

  const handleRemoveAttachment = (media: any) => {
    setDisplayMediaList(
      displayMediaList?.filter(
        (displayMedia: any) =>
          displayMedia?.clientMediaID !== media?.clientMediaID
      )
    );
    switch (media.type) {
      case 1:
        _.remove(ImageService.displayImageList, {
          clientMediaID: media.clientMediaID,
        });
        break;
      case 2:
        _.remove(AudioService.displayAudioList, {
          clientMediaID: media.clientMediaID,
        });
        break;
      case 3:
        _.remove(VideoService.displayVideoList, {
          clientMediaID: media.clientMediaID,
        });
        break;
    }
  };

  const handleRemoveAttachments = () => {
    setDisplayMediaList([]);
    ImageService.displayImageList = [];
    AudioService.displayAudioList = [];
    VideoService.displayVideoList = [];
  }

  const handlePrviewClik = (media: any) => {
    if (media?.type === 1) {
      viewWebImage(media.clientMediaID);
    } else if (media?.type === 2) {
      setAudioUrl(media?.nativeURL);
      setIsAudioModalOpen(true);
    } else if (media?.type === 3) {
      setVideoUrl(media?.nativeURL);
      viewVideo();
    }
  };

  const AttachementCard = ({ media }: any) => {
    return (
      <div className="attachment-card">
        <div
          style={{ width: "70%" }}
          onClick={() => {
            handlePrviewClik(media);
          }}
        >
          {media?.type === 1 && (
            <>
              <div className="media-message-container">
                <IonIcon icon={imageOutline} />
                <div className="media-detials-container">
                  <p className="media-name-txt">{media?.name}</p>
                  <p className="size-txt">{media?.size}</p>
                </div>
              </div>

              <img
                className="hide-media-image"
                id={`media-${media.clientMediaID}`}
                src={media.nativeURL}
                alt="media"
              />
            </>
          )}
          {media?.type === 3 && (
            <>
              <div className="media-message-container">
                <IonIcon icon={videocamOutline} />
                <div className="media-detials-container">
                  <p className="media-name-txt">{media?.name}</p>
                  <p className="size-txt">{media?.size}</p>
                </div>
              </div>
            </>
          )}
          {media?.type === 2 && (
            <div className="media-message-container">
              <IonIcon icon={volumeHighOutline} />
              <div className="media-detials-container">
                <p className="media-name-txt">{media?.name}</p>
                <p className="size-txt">{media?.size}</p>
              </div>
            </div>
          )}
        </div>
        <div
          className="remove-icon-container"
          onClick={() => handleRemoveAttachment(media)}
        >
          <IonIcon icon={closeCircleOutline} />
        </div>
      </div>
    );
  };

  const showAudioErrorMessage = () => {
    Toast.error(CONSTANTS.MESSAGES.NO_AUDIO_DEVICE);
  };

  const [isOpenSpecialityContainer, setIsOpenSpecialityContainer] =
    useState<boolean>(false);
  const [infoPopoverVisible, setInfoPopoverVisible] = useState<boolean>(false);

  const maxSubtitleLength = 30;
  const specialityNames = selectedUserMsg?.thread_users[0]?.specialty_names
    ? selectedUserMsg?.thread_users[0]?.specialty_names
      ?.map((speciality: any) => speciality)
      ?.join(",")
    : selectedUserMsg?.thread_users[0]?.speciality
      ?.toString();

  const shouldShowEyeIcon = specialityNames?.length > maxSubtitleLength;
  const displayedSubtitle = shouldShowEyeIcon
    ? `${specialityNames?.substring(0, maxSubtitleLength)}...`
    : specialityNames;

  const subtitleArray = Array.isArray(specialityNames)
    ? specialityNames
    : specialityNames?.split(",")?.map((item: any) => item?.trim());


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchMessageDetails(1, selectedNetwork, searchText);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, selectedNetwork]);


  const getNetworkList = async () => {
    const apiResponse: NetworkListResponseModal = await OnCallLookUpInputService.getOnCallLookUpNetworksList({
      reg_code: utilService.getNetwork(),
    });

    if (apiResponse.isSuccess) {
      const networkList_res: any = apiResponse?.networkData
      setNetworkList(networkList_res?.data);
      // onCallSearchResultService.setonCallSiteListFromComponent(networkList_res);
    }
  };

  const onNetworkChange = (value: any) => {
    setChoosenNetwork(value)
  }

  const handleNetworkModalClose = () => {
    setIsNetworkModalOpen(false)
    setChoosenNetwork(selectedNetwork)
    setSelectedNetwork(selectedNetwork)
  }

  const handleNetworksubmit = () => {
    setSelectedNetwork(choosenNetwork)
    setIsNetworkModalOpen(false)
    fetchMessageDetails(1, choosenNetwork)
    setSelectedUserMsg(null)
  }

  const handleNetworkClear = () => {
    setSelectedNetwork(null)
    setChoosenNetwork(null)
    setIsNetworkModalOpen(false)
    fetchMessageDetails(1, "")
  }


  return (
    <IonRow className="user-chat-web-page">
      <IonAlert
        isOpen={showMessageDeleteAlert}
        onDidDismiss={() => setShowMessageDeleteAlert(false)}
        cssClass="message-list-delete-alert"
        header={t("confirmationMessage")}
        message={t("deleteMessageConfirm")}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("yes"),
            handler: () => {
              handleDeleteAction(1, deleteMessageItem?.id);
            },
          },
        ]}
      />
      <IonAlert
        isOpen={showChatDeleteAlert}
        onDidDismiss={() => setShowChatDeleteAlert(false)}
        cssClass="message-list-delete-alert"
        header={t("confirmationMessage")}
        message={t("deleteChatConfirm")}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("yes"),
            handler: () => {
              handleDeleteAction(2, "");
            },
          },
        ]}
      />
      {!location?.state?.isFullscreen && (
        <IonCol size="12" className="messages-header-col">
          <div
            className={`file-share-select-user-header ${props.isModalPopUpScreen
              ? "file-share-select-user-header-height"
              : ""
              }`}
          >
            <div className="header-label">
              <p className="header-title">{t("messages", "Messages")}</p>
              <p className="header-subtitle">{t("messagesSubtitle", "Threads about a shift, a patient or a handover — never a separate inbox.")}</p>
            </div>
            <div className="header-actions">
              {isN2nPermission && <div className="selection-btn-container" onClick={() => setIsNetworkModalOpen(true)}>
                <p>{selectedNetwork ?? t("selectNetwork")}</p>
                <div>
                  <img src={DownArrowIcon} alt="" />
                </div>
              </div>}
              <button
                className="add-new-message-btn"
                onClick={() => {
                  history.push({
                    pathname: "/client/file-share/selectuser",
                    state: {
                      isFromNewChat: true,
                      n2nNetwork: selectedNetwork ?? ""
                    },
                  });
                }}
              >
                + {t("newMessage", "New message")}
              </button>
            </div>
            <IonModal
              isOpen={isNetworkModalOpen}
              backdropDismiss={false}
              className="add-schedule-model modal-popup-wrapper-nurse-site messages-network-modal"
            // onDidDismiss={() => props.onOk(selectScheduleListData)}
            >
              <div className="header-section">
                <p>{t("networks")}</p>
                <div onClick={handleNetworkModalClose}>
                  <img src={RedCloseIcon} alt="" />
                </div>
              </div>
              <div className="network-list-section">
                <IonGrid className="scrollbar">
                  <IonRow>
                    <IonCol>
                      <IonList className="items">
                        {networkList?.length > 0 ?
                          <IonRadioGroup
                            value={choosenNetwork}
                            onIonChange={(e) => onNetworkChange(e.detail.value)}
                            className="network-radio-group"
                          >
                            {networkList?.map((item: any, index: number) => {
                              return (
                                <>
                                  <IonItem lines="none" className="network-item">
                                    <IonRadio value={item?.network} className="network-radio" />
                                    <IonLabel className="network-label-name">{item?.network}</IonLabel>
                                  </IonItem>
                                </>
                              )
                            })}
                          </IonRadioGroup>
                          : (
                            <div className="no-results-label">{t("noNetworks")}</div>
                          )}
                      </IonList>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
              <div className="footer-section">
                <button
                  className="clear-btn"
                  onClick={handleNetworkClear}>
                  {t("clear")}
                </button>
                <button
                  className="ok-btn"
                  onClick={handleNetworksubmit}>
                  {t("ok")}
                </button>
              </div>
            </IonModal>
          </div>
        </IonCol>
      )}
      {!location?.state?.isFullscreen && (
        <IonCol size-xl="4" size-lg="4.5" size-md="5" size="12">
          <div className="user-chat-component-container">
            <div className="user-chat-container">
              <div className="dropdown-main-container">
                <div className="searchbar-containar-item">
                  <IonSearchbar
                    debounce={1000}
                    value={searchText}
                    disabled={isShowPopOver}
                    onIonChange={(e) => {
                      setSearchText(e.detail.value!);
                      // fetchMessageDetails(1, selectedNetwork, e.detail.value);
                    }}
                    onIonClear={(e) => {
                      setSearchText("");
                      setPageNo(1);
                    }}
                    placeholder={t("searchThreads", "Search by name, speciality or ward...")}
                    type="search"
                    autocomplete="off"
                    autoCorrect="off"
                    className="searchbar"
                  ></IonSearchbar>
                </div>
              </div>
              <div className="thread-list-card">
              <div className="thread-list-subheader">
                <span className="thread-list-label">{t("threads", "Threads")}</span>
                {messageListData?.filter((item: any) => item?.unread_message_count !== 0)?.length > 0 && (
                  <span className="thread-list-unread-count">
                    {messageListData.filter((item: any) => item?.unread_message_count !== 0).length} {t("unread", "unread")}
                  </span>
                )}
              </div>
              {isMessageLoaderActive ?
                <div className="loader-container">
                  <Loader></Loader>
                </div>
                :
                <IonGrid className="message-page-grid ">
                  <InfiniteScroll
                    className=""
                    dataLength={messageListData.length}
                    height={`70vh`}
                    next={() => onScroll()}
                    hasMore={!!messageNextValue}
                    loader={<div></div>}
                  >
                    <IonRow className="site-list-container">
                      {!_.isEmpty(messageListData)
                        ? messageListData.map((item: any, index: any) => (
                          <MessageListCard
                            key={item.id}
                            listData={item}
                            index={index}
                            componentName={nextPage}
                            isUserChatWebComponent={true}
                            updateForwardMessages={updateForwardMessage}
                            getSelectedMessageCard={handleMessageCardSelection}
                            updateList={updateMessageList}
                            selectedUsrMsg={selectedUserMsg}
                            handleClick={() => {
                              setForwardMessage(false)
                              handleMessageClick(
                                item,
                                item?.is_group_sms ? 2 : 1,
                                item?.message_settings?.thread_users_network?.toString()
                              );
                              //  setNetworkSettings(item?.message_settings)
                            }}

                          />
                        ))
                        : !isMessageLoaderActive && (
                          <div className="no-results-label">
                            {t("noMessagesAvailable")}
                          </div>
                        )}
                    </IonRow>
                  </InfiniteScroll>
                </IonGrid>
              }
              </div>
            </div>
          </div>
        </IonCol>
      )}
      {(messageListData.length > 0 || location?.state?.isFullscreen) && (
        <IonCol size-xl={location?.state?.isFullscreen ? "12" : "8"} size-lg={location?.state?.isFullscreen ? "12" : "7.5"} size-md={location?.state?.isFullscreen ? "12" : "7"} size="12">
          {isLoaderActive && (
            <div className="loader-container">
              <Loader></Loader>
            </div>
          )}
          {!isForwardMessage ? (
            <div className="user-chat-message-details-container">
              {location?.state?.isMultiSendEnabled ? (
                <div className="chat-page-header-section">
                  <div
                    className="back-icon"
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    <IonIcon icon={chevronBackOutline} />
                  </div>
                  <h1 className="send-msg-title">{t("sendMessage")}</h1>
                </div>
              ) : (
                <div className="chat-page-header-section">
                  {location?.state?.isFullscreen && (
                    <div
                      className="back-icon"
                      onClick={() => {
                        if (location?.state?.from === "notifications") {
                          history.push({
                            pathname: "/client/notifications",
                          });
                        } else {
                          history.goBack();
                        }
                      }}
                    >
                      <IonIcon icon={chevronBackOutline} />
                    </div>
                  )}
                  <div className="profile-picture-container">
                    {selectedUserMsg?.is_group_sms ? (
                      <div className="group-sms-icon-container">
                        <IonIcon
                          icon={peopleOutline}
                          className="icon-div"
                          size="large"
                        />
                      </div>
                    ) : (
                      <img
                        className="profile-picture"
                        src={
                          selectedUserMsg?.thread_avatar
                            ? `${utilService.getBaseUrl()}/${selectedUserMsg.thread_avatar}`
                            : "assets/images/defaultProfilePic.png"
                        }
                        onError={(
                          e: React.SyntheticEvent<HTMLImageElement, Event>
                        ) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "assets/images/defaultProfilePic.png";
                        }}
                        alt=""
                      />
                    )}
                    {!selectedUserMsg?.is_group_sms && (
                      <span className="online-dot"></span>
                    )}
                  </div>
                  <div className="profile-details-container">
                    <Popover
                      isOpen={membersInfoListPopoverOpen}
                      positions={["bottom"]}
                      padding={10}
                      containerStyle={{
                        zIndex: "1",
                      }}
                      align={"start"}
                      onClickOutside={() =>
                        setMembersInfoListPopoverOpen(false)
                      }
                      content={({ position, childRect, popoverRect }) => (
                        <div
                          className="members-info-list-popover-container"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {selectedUserMsg?.thread_users?.map((user: any) => (
                            <MembersCard
                              member={user}
                              isCallEnabled={true}
                              isSelectionEnabled={false}
                              initiateApiCall={() => {
                                setSelectedCallGuid(user?.guid);
                                setMembersInfoListPopoverOpen(
                                  !membersInfoListPopoverOpen
                                );
                                initiateApiCall({
                                  guid: user?.guid,
                                  reg_code: utilService.getNetwork(),
                                  n2n_network: networkSettings?.thread_users_network?.toString() ?? ""
                                });
                              }}
                              setMbrSpecialityValues={setMbrSpecialityValues}
                              toggleSpecilityModal={() => {
                                setMembersInfoListPopoverOpen(false);
                                setIsOpenMbrSpecialityContainer(
                                  !isOpenMbrSpecialityContainer
                                );
                              }}
                            />
                          ))}
                        </div>
                      )}
                    >
                      <div
                        className="group-name-container"
                        onClick={() => setMembersInfoListPopoverOpen(true)}
                      >
                        <p className="profile-name">
                          {selectedUserMsg?.is_group_sms
                            ? selectedUserMsg?.thread_users
                              ?.map((user: any) => user?.first_name)
                              ?.join(", ")
                            : selectedUserMsg?.thread_users?.[0]?.last_name
                              ? `${selectedUserMsg?.thread_users[0]?.first_name} ${selectedUserMsg?.thread_users[0]?.last_name}`
                              : selectedUserMsg?.thread_users?.[0]?.first_name || "Sarah Benyahia"}
                        </p>
                        {selectedUserMsg?.is_group_sms && (
                          <IonIcon icon={chevronDownOutline} />
                        )}
                      </div>
                    </Popover>
                    {!selectedUserMsg?.is_group_sms && (
                      <div className="speciality-Container">
                        <p className="recent-message">{displayedSubtitle}</p>
                        {shouldShowEyeIcon && (
                          <div
                            onClick={() => setIsOpenSpecialityContainer(true)}
                          >
                            <IonIcon icon={eyeOutline} />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="icons-container">
                    <div
                      className="green-call-btn"
                      title="Call"
                      onClick={() => {
                        if (selectedUserMsg?.thread_users?.[0]?.guid) {
                          setSelectedCallGuid(selectedUserMsg.thread_users[0].guid);
                          initiateApiCall({
                            guid: selectedUserMsg.thread_users[0].guid,
                            reg_code: utilService.getNetwork(),
                          });
                        }
                      }}
                    >
                      <IonIcon icon={callOutline} />
                    </div>
                    <div
                      className="header-options-btn"
                      title="Options"
                      onClick={() => setShowChatDeleteAlert(true)}
                    >
                      <IonIcon icon={ellipsisVertical} />
                    </div>
                  </div>
                </div>
              )}
              <div
                className="message-list-container"
                id="chatContainer"
                style={{ height: selectedReplyMessage ? "62%" : "70%" }}
              >
                {!location?.state?.isMultiSendEnabled &&
                  !isLoaderActive &&
                  (chatList?.length > 0 ? (
                    <InfiniteScroll
                      className=""
                      dataLength={chatList?.length}
                      height={"100%"}
                      scrollThreshold={0.3}
                      scrollableTarget="chatContainer"
                      next={() => {
                        onChatListScroll();
                      }}
                      // hasMore={chatList?.length<chatListCount}
                      hasMore={!!messageNextValue}
                      loader={<div></div>}
                      inverse={true}
                      style={{
                        // width: "100%",
                        // height:"100%",
                        display: "flex",
                        flexDirection: "column-reverse",
                        justifyContent: "flex-end",
                        padding: "1rem",
                        overflow: "auto",
                        // overflow:"scroll"
                      }}
                    >
                      {chatList?.map((message: any, index) => (
                        <UserMessageCardComponent
                          key={message?.id || index}
                          message={message}
                          handleReply={handleReply}
                          handleForward={handleForward}
                          handleDelete={handleDeleteMessage}
                        />
                      ))}
                    </InfiniteScroll>
                  ) : (
                    <div className="empty-div">
                      {t("noChatsFound")}
                    </div>
                  ))}
              </div>
              <div className="bottom-section-container">

                {displayMediaList?.length > 0 && (
                  <Popover
                    isOpen={isAttachmentListPopoverVisibile}
                    positions={["top"]}
                    padding={10}
                    onClickOutside={() => {
                      setIsAttachmentListPopoverVisibile(false);
                    }}
                    containerStyle={{
                      marginLeft: "-2rem",
                    }}
                    content={({ position, childRect, popoverRect }) => (
                      <div
                        className="attachement-popover-container"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {displayMediaList?.map((media: any, index: number) => {
                          return <AttachementCard key={media?.id || index} media={media} />;
                        })}
                      </div>
                    )}
                  >
                    <div
                      className="attachment-btn"
                      onClick={(e: any) => {
                        setIsAttachmentListPopoverVisibile(true);
                      }}
                    >
                      <IonIcon icon={attachOutline} />
                      <p>
                        {displayMediaList?.length > 1
                          ? `${displayMediaList?.length} ${t("attachments")}`
                          : t("attachment")}
                      </p>
                    </div>
                  </Popover>
                )}
                {/* {videoUrl && ( */}
                <ReactPlayer
                  ref={(ref) => setPlayer(ref)}
                  url={videoUrl}
                  light={false}
                  // onClickPreview={preview}
                  controls={true}
                  width={0}
                  height={0}
                />
                {/* )} */}
                <div className="reply-and-input-container">
                  {selectedReplyMessage && (
                    <div className="reply-box-container">
                      <div className="reply-box">
                        <p className="from-user-name">
                          {selectedReplyMessage?.from_user?.first_name}
                        </p>
                        <div
                          className="reply-close-icon"
                          onClick={() => handleCloseRplyMsg()}
                        >
                          <IonIcon icon={closeCircleOutline} />
                        </div>
                        {(() => {
                          const replyMediaItem =
                            Array.isArray(selectedReplyMessage?.media_data) &&
                            selectedReplyMessage.media_data.length > 0
                              ? selectedReplyMessage.media_data[0]
                              : null;
                          return !selectedReplyMessage?.message_has_media ? (
                            <p>{selectedReplyMessage?.message_text}</p>
                          ) : (
                            <>
                              {replyMediaItem?.media_type === "Image" && (
                                <div className="media-message-container">
                                  <IonIcon icon={imageOutline} />
                                  <p>{replyMediaItem?.media_name}</p>
                                </div>
                              )}
                              {replyMediaItem?.media_type === "Video" && (
                                <div className="media-message-container">
                                  <IonIcon icon={videocamOutline} />
                                  <p>{replyMediaItem?.media_name}</p>
                                </div>
                              )}
                              {replyMediaItem?.media_type === "Audio" && (
                                <div className="media-message-container">
                                  <IonIcon icon={volumeHighOutline} />
                                  <p>{replyMediaItem?.media_name}</p>
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                  {isRecording ? (
                    <div className="messenger-voice-recording-bar">
                      <div
                        className="voice-trash-btn"
                        title={t("cancel") || "Cancel"}
                        onClick={(e) => {
                          e.stopPropagation();
                          stopTimerInUI();
                          setIsRecording(false);
                          setAudioRecordCss(false);
                          setDisableMediaSection(false);
                          dataTransferService.transferAudioMediaAction(false);
                        }}
                      >
                        <IonIcon icon={trashOutline} />
                      </div>

                      <div className="voice-center-status">
                        <span className="rec-live-dot"></span>
                        <div className="timer-div">
                          <span className="mins">00</span>
                          <span className="divider">:</span>
                          <span className="sec">00</span>
                        </div>
                        <div className="voice-wave-bars">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>

                      <button
                        className="voice-send-btn"
                        title={t("send") || "Send"}
                        onClick={(e) => {
                          e.stopPropagation();
                          onAudioRecBtnClick();
                        }}
                      >
                        <IonIcon icon={sendOutline} />
                      </button>
                    </div>
                  ) : (
                    <div className="input-container-wrapper">
                      <div className="input-container ">
                        <Popover
                          isOpen={isOpenAttachmentActionPopover}
                          positions={["top"]}
                          padding={10}
                          onClickOutside={() =>
                            setIsOpenAttachmentActionPopover(false)
                          }
                          content={({ position, childRect, popoverRect }) => (
                            <div className={`capture-media`}>
                              <div
                                onClick={() => {
                                  setIsOpenAttachmentActionPopover(false);
                                  // setIsCaptureMediaPopOver(false);
                                }}
                                className="close-icon"
                              >
                                <IonIcon icon={close}></IonIcon>
                              </div>
                              <div className="attach-media-icons-wrapper">
                                <div className="add-media-icon-div">
                                  <div
                                    className="add-media-icon icon-video-section"
                                    onClick={(e: any) => {
                                      // openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO);
                                      setIsVideoActionSheetOpen(true);
                                      // setIsOpenAttachmentActionPopover(false);
                                      // setIsCaptureMediaPopOver(false);
                                    }}
                                  >
                                    <div className="input-icon icon-div">
                                      <IonIcon
                                        icon={videocam}
                                        className="media-upload-icon"
                                      ></IonIcon>
                                    </div>
                                    <div className="media-label">{t("video")}</div>
                                  </div>
                                </div>
                                <IonActionSheet
                                  isOpen={isVideoActionSheetOpen}
                                  header={t("video")}
                                  onDidDismiss={({ detail }) => {
                                    if (detail?.data?.action === "upload") {
                                      attachVideoInputRef?.current?.click();
                                      // webAttachMedia(CONSTANTS.MEDIA_TYPE.VIDEO)
                                    } else if (
                                      detail?.data?.action === "record"
                                    ) {
                                      openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO);
                                    }
                                    setIsVideoActionSheetOpen(false);
                                  }}
                                  buttons={[
                                    {
                                      text: t("fromVideos"),
                                      data: {
                                        action: "upload",
                                      },
                                    },
                                    {
                                      text: t("recordVideo"),
                                      data: {
                                        action: "record",
                                      },
                                    },
                                    {
                                      text: t("cancel"),
                                      role: "cancel",
                                      data: {
                                        action: "cancel",
                                      },
                                    },
                                  ]}
                                ></IonActionSheet>
                                <div className="add-media-icon-div">
                                  <div
                                    className="add-media-icon icon-audio-div"
                                    onClick={() => {
                                      setShowNewPopover(false);
                                      // setIsCaptureMediaPopOver(false);
                                      // onAudioRecBtnClick();
                                      setIsAudioActionSheetOpen(true);
                                    }}
                                  >
                                    <div className="input-icon icon-div">
                                      <IonIcon
                                        icon={mic}
                                        className="media-upload-icon"
                                      ></IonIcon>
                                    </div>
                                    <div className="media-label">{t("audio")}</div>
                                  </div>
                                </div>

                                <IonActionSheet
                                  isOpen={isAudioActionSheetOpen}
                                  header={t("audio")}
                                  onDidDismiss={({ detail }) => {
                                    if (detail?.data?.action === "upload") {
                                      openFileSelector();
                                    } else if (
                                      detail?.data?.action === "record"
                                    ) {
                                      onAudioRecBtnClick();
                                    }
                                    setIsAudioActionSheetOpen(false);
                                  }}
                                  buttons={[
                                    {
                                      text: t("fromAudios"),
                                      data: {
                                        action: "upload",
                                      },
                                    },
                                    {
                                      text: t("recordAudio"),
                                      data: {
                                        action: "record",
                                      },
                                    },
                                    {
                                      text: t("cancel"),
                                      role: "cancel",
                                      data: {
                                        action: "cancel",
                                      },
                                    },
                                  ]}
                                ></IonActionSheet>
                                <IonActionSheet
                                  isOpen={isImageActionSheetOpen}
                                  header={t("image")}
                                  onDidDismiss={({ detail }) => {
                                    if (detail?.data?.action === "upload") {
                                      takePhoto(CameraSource.Photos);
                                    } else if (
                                      detail?.data?.action === "record"
                                    ) {
                                      takePhoto(CameraSource.Camera);
                                    }
                                    setIsImageActionSheetOpen(false);
                                  }}
                                  buttons={[
                                    {
                                      text: t("fromPhotos"),
                                      data: {
                                        action: "upload",
                                      },
                                    },
                                    {
                                      text: t("takePicture"),
                                      data: {
                                        action: "record",
                                      },
                                    },
                                    {
                                      text: t("cancel"),
                                      role: "cancel",
                                      data: {
                                        action: "cancel",
                                      },
                                    },
                                  ]}
                                ></IonActionSheet>
                                <div className="add-media-icon-div">
                                  <div
                                    className="add-media-icon icon-image-section"
                                    onClick={() => {
                                      setShowNewPopover(false);
                                      // setIsCaptureMediaPopOver(false);
                                      setIsImageActionSheetOpen(true);
                                    }}
                                  >
                                    <div className="input-icon icon-div">
                                      <IonIcon
                                        icon={camera}
                                        className="media-upload-icon"
                                      ></IonIcon>
                                    </div>
                                    <div className="media-label">{t("image")}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div
                            className="attachment-icon-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsOpenAttachmentActionPopover((prev) => !prev);
                            }}
                          >
                            <IonIcon
                              icon={attachOutline}
                              className="input-attachment-icon"
                            />
                          </div>
                        </Popover>
                        <textarea
                          value={message}
                          placeholder="Write a message..."
                          ref={textareaRef}
                          onChange={handleInput}
                          className={`message-input ${selectedReplyMessage ? "half-curved" : ""
                            }`}
                          maxLength={250}
                        // rows={2}
                        />
                        <IonModal
                          isOpen={showVideoUploadModal}
                          backdropDismiss={false}
                          className="audio-upload-modal video-upload-modal"
                        >
                          <div
                            className="close-icon"
                            onClick={() => {
                              setShowVideoUploadModal(false);
                              setMediaList();
                            }}
                          >
                            <IonIcon icon={close}></IonIcon>
                          </div>
                          <VideoComponent
                            onComplete={() => {
                              onComplete(CONSTANTS.MEDIA_TYPE.VIDEO);
                            }}
                            selectedDoctorData={() => { }}
                            isStatusBoard={props.isStatusBoard}
                          // smsThread={getSMSThreadId()}
                          ></VideoComponent>
                        </IonModal>
                      </div>
                      <Popover
                        isOpen={isSendActionPopoverOpen}
                        positions={["top"]}
                        padding={10}
                        onClickOutside={() => setIsSendActionPopoverOpen(false)}
                        content={({ position, childRect, popoverRect }) => (
                          <div className="send-btn-action-popover">
                            <div
                              className="action-btn-container"
                              onClick={() => handleSendMessage(true, false)}
                            >
                              <IonIcon icon={navigateOutline} />
                              <p>{t("all")}</p>
                            </div>
                            <div
                              className="action-btn-container"
                              onClick={() => setIsSelectUserModalOpen(true)}
                            >
                              <IonIcon icon={peopleOutline} />
                              <p>{t("all")}</p>
                            </div>
                          </div>
                        )}
                      >
                        <div className="message-action-container">
                          <div className="send-btn-wrapper">
                            <button
                              className="send-btn"
                              disabled={
                                (!message && displayMediaList?.length === 0) &&
                                !networkSettings?.is_message_permitted
                              }
                              style={{
                                opacity:
                                  !message && displayMediaList?.length === 0
                                    ? 0.6
                                    : 1,
                              }}
                              onClick={() => {
                                if (
                                  selectedUserMsg?.is_group_sms &&
                                  !location?.state?.isMultiSendEnabled &&
                                  chatList?.length > 0
                                ) {
                                  setIsSendActionPopoverOpen(true);
                                } else {
                                  handleSendMessage(true, false);
                                }
                              }}
                            >
                              {!isMessageSentLoader ? (
                                <IonIcon icon={sendOutline} />
                              ) : (
                                <div className="send-loader-container">
                                  <div className="send-loader"></div>
                                </div>
                              )}
                            </button>
                          </div>
                        </div>
                      </Popover>
                      <IonModal
                        isOpen={isSelectUserModalOpen}
                        backdropDismiss={false}
                        className="group-select-user-modal"
                      >
                        <div className="group-select-user-modal-container">
                          <input
                            placeholder={t("search")}
                            className="search-input"
                            value={modalInpuValue}
                            onChange={handleModalInputChange}
                          />
                          <div className="members-card-list-container">
                            {threadUsers?.filter(
                              (user: any) =>
                                user?.guid !== utilService.getLoggedUserGuid()
                            )?.length > 0 ? (
                              threadUsers
                                ?.filter(
                                  (user: any) =>
                                    user?.guid !== utilService.getLoggedUserGuid()
                                )
                                ?.map((user: any, index: number) => {
                                  return (
                                    <MembersCard
                                      key={user?.guid || user?.id || index}
                                      member={user}
                                      selectedUsers={selectedUsers}
                                      handleGrpUserSelect={handleGrpUserSelect}
                                      isSelectionEnabled={true}
                                      isCallEnabled={false}
                                      setMbrSpecialityValues={
                                        setSlctMbrSpecialityValues
                                      }
                                      toggleSpecilityModal={() => {
                                        setIsOpenSlctMbrSpecialityContainer(
                                          !isOpenMbrSpecialityContainer
                                        );
                                      }}
                                    />
                                  );
                                })
                            ) : (
                              <div className="empty-div">
                                <h3>{t("noResultFound")}</h3>
                              </div>
                            )}
                          </div>
                          <div className="footer-container">
                            <button
                              onClick={() => handleModalCancel()}
                              style={{ backgroundColor: "#575c61" }}
                            >
                              {t("cancel")}
                            </button>
                            <button
                              disabled={selectedUsers?.length === 0}
                              style={{
                                backgroundColor: "var(--button-bg-tertiary)",
                                opacity: selectedUsers?.length === 0 ? 0.6 : 1,
                              }}
                              onClick={() => handleSendMessage(false, false)}
                            >
                              {!isMessageSentLoader ? (
                                t("send")
                              ) : (
                                <div className="send-loader-container">
                                  <div
                                    className="send-loader"
                                    style={{ width: "1.5rem", height: "1.5rem" }}
                                  ></div>
                                </div>
                              )}
                            </button>
                          </div>
                        </div>
                      </IonModal>
                    </div>
                  )}
                </div>
                <AudioComponent
                  onComplete={() => {
                    onComplete(CONSTANTS.MEDIA_TYPE.AUDIO);
                  }}
                  selectedDoctorData={() => { }}
                  isStatusBoard={props.isStatusBoard}
                // smsThread={getSMSThreadId()}
                ></AudioComponent>
              </div>
            </div>
          ) : (
            <div className="user-chat-message-details-container">
              <div className="file-share-select-user-header">
                <div
                  className="back-icon"
                  onClick={() => {
                    handleUserMessageOnCancel();
                  }}
                >
                  <IonIcon icon={chevronBackOutline} />
                </div>
                <div className="header-label">{t("select")}</div>
              </div>
              <SelectUserComponent
                onCancel={() => {
                  // setIsShowSelectUserModal(false);
                  // setIsShowMediaListModal(true);
                  // handleUserMessageOnCancel();
                  handleUserMessageOnCancel();
                }}
                dataFromParentComponent={dataFromParentComponent}
                getSelectedCard={() => { }}
                isMessageComponent={true}
                isForwardMessage={true}
                forwardMessageDetails={selectedforwardMessage}
                n2nNetwork={networkSettings?.thread_users_network?.toString() ?? ""}
              ></SelectUserComponent>
            </div>
          )}
        </IonCol>
      )}
      <AudioModal
        isOpen={isAudioModalOpen}
        onClose={() => setIsAudioModalOpen(false)}
        audioBlobUrl={audioUrl}
      />
      <SpecialityModal
        isOpen={isOpenSpecialityContainer}
        onClose={() => setIsOpenSpecialityContainer(false)}
        values={subtitleArray}
        title={"Speciality"}
      />
      <input
        ref={attachVideoInputRef}
        id="file"
        style={{
          opacity: "0",
          display: "hidden",
        }}
        multiple
        name="video-file"
        accept="video/mp4,video/x-m4v,video/*"
        type="file"
        value=""
        onChange={() => webAttachMedia(CONSTANTS.MEDIA_TYPE.VIDEO)}
      />
      <SpecialityModal
        isOpen={isOpenMbrSpecialityContainer}
        onClose={() => {
          setIsOpenMbrSpecialityContainer(false);
          setMembersInfoListPopoverOpen(true);
        }}
        values={mbrSpecialityValues}
        title={"Speciality"}
      />
      <SpecialityModal
        isOpen={iOpenSlctMbrSpecialityContainer}
        onClose={() => {
          setIsOpenSlctMbrSpecialityContainer(false);
        }}
        values={slctMbrSpecialityValues}
        title={"Speciality"}
      />
      <IonModal
        isOpen={isShowCallModal}
        backdropDismiss={false}
        className="call-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>{t("confirmationMessage")}</IonTitle>
          </IonToolbar>
        </IonHeader>
        {doctorInfoData && (
          <IonContent className="content-container">
            <IonRow
              className={`confirm-label ${!isSecondaryNUmberExist ? "confirm-label-padding" : ""
                }`}
            >
              <IonCol>{t("confirmCall")}</IonCol>
            </IonRow>
            <IonGrid className="grid-container">
              {isSecondaryNUmberExist && (
                <IonRow className="call-with-label">
                  <IonCol>{t("callWith")}</IonCol>
                </IonRow>
              )}
              <IonRow className="primary-button-row">
                <IonCol>
                  {/* <IonButton
                    className="submit-btn button primary-btn  primary-button"
                    shape="round"
                    onClick={() => {
                      setIsShowCallModal(false);
                      setIsPrimaryNumber(true);
                      fetchAllDataFromApi(false);
                    }}
                  >
                    <IonIcon slot="start" icon={callOutline} />
                    Primary Number
                  </IonButton> */}
                </IonCol>
              </IonRow>
              {isSecondaryNUmberExist && (
                <IonRow className="secondary-button-row">
                  <IonCol>
                    {/* <IonButton
                      className="submit-btn button primary-btn  secondary-button"
                      shape="round"
                      onClick={() => {
                        setIsShowCallModal(false);
                        setIsPrimaryNumber(false);
                        fetchAllDataFromApi(false);
                      }}
                    >
                      <IonIcon slot="start" icon={callOutline} />
                      Secondary Number
                    </IonButton> */}
                  </IonCol>
                </IonRow>
              )}



              <IonRow className="callCentral-button-row">
                <IonCol>
                  <IonButton
                    className="submit-btn button primary-btn  callCentral-button"
                    shape="round"
                    onClick={() => {
                      setIsShowCallModal(false);
                      setIsPrimaryNumber(false);
                      fetchAllDataFromApi(true);
                    }}
                  >
                    <IonIcon slot="start" icon={callOutline} />
                    {t("callCentralApp")}
                  </IonButton>
                </IonCol>
              </IonRow>
              <IonRow
                className={`no-label ${!isSecondaryNUmberExist ? "no-label-padding" : ""
                  }`}
              >
                <IonCol>
                  <div
                    className="confirm-btn clickable no-button"
                    onClick={() => {
                      setMembersInfoListPopoverOpen(true);
                      setIsShowCallModal(false);
                    }}
                  >
                    {t("no")}
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        )}
      </IonModal>
      {doctorInfoData.userData && isShowCallUserModal && (
        <CallUser
          doctorInfoData={doctorInfoData}
          capabilityTokenData={capabilityTokenInfo}
          isShowCallUserModal={isShowCallUserModal}
          isPrimaryNumber={isPrimaryNumber}
          isAssignedNumber={props.isAssignedNumber}
          listData={props.listData}
          onOk={() => {
            setIsShowCallUserModal(false);
          }}
          onCancel={() => {
            setIsShowCallUserModal(false);
          }}
        ></CallUser>
      )}
      {/* <IonAlert
  isOpen={showUrgentAlert}
  onDidDismiss={() => setShowUrgentAlert(false)}
  header="Critical Message"
  message="You areing a critical message. Please confirm."
  buttons={[
    {
      text: "Cancel",
      role: "cancel",
      handler: () => setShowUrgentAlert(false),
    },
    {
      text: "Send",
      handler: () => {
        handleSendMessage(false, true); // 👈 send as urgent
        setShowUrgentAlert(false);
      },
    },
  ]}
/> */}


      {/* Urgent Message Confirmation Alert */}
      <IonAlert
        isOpen={showUrgentAlert}
        onDidDismiss={() => setShowUrgentAlert(false)}
        header={t('Message Confirmation') || 'Message Confirmation'}
        message={t('Are you sure you want to send this message as urgent?') || 'Are you sure you want to send this message as urgent?'}
        buttons={[
          {
            text: t('no') || 'No',
            role: 'cancel',
            handler: () => setShowUrgentAlert(false),
            cssClass: 'secondary',
          },
          {
            text: t('yes') || 'Yes',
            handler: () => {
              handleSendMessage(false, true); // send as urgent
              setShowUrgentAlert(false);
            },
          },
        ]}
      />

      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="call-alert"
        header={t("confirmationMessage")}
        message={t("confirmCall")}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("ok"),
            handler: () => {
              setIsPrimaryNumber(true);
              fetchAllDataFromApi(false);
            },
          },
        ]}
      />

    </IonRow>
  );
};

export default UserChatWebComponent;

const AudioModal: React.FC<any> = ({ isOpen, onClose, audioBlobUrl }) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="audio-modal">
      <div className="header-section-container">
        <h2>{t("audioPlayer")}</h2>
        <div className="close-container" onClick={onClose}>
          <IonIcon icon={closeCircleOutline} slot="end" />
        </div>
      </div>
      <IonContent>
        <div className="audio-player-container">
          <audio autoPlay controls controlsList="nodownload">
            <source src={audioBlobUrl} />
            Your browser does not support the audio element.
          </audio>
        </div>
      </IonContent>
    </IonModal>
  );
};

export const SpecialityModal: React.FC<any> = ({ isOpen, onClose, values, title }) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      className="speciality-modal"
    >
      {/* <IonHeader > */}
      <div className="header-section-container">
        <h2>{title}</h2>
        <div className="close-container" onClick={onClose}>
          <IonIcon icon={closeCircleOutline} slot="end" />
        </div>
      </div>
      {/* </IonHeader> */}
      <IonContent>
        <div className="specialty-tag-container">
          {values?.map((value: any, index: number) => {
            return (
              <div key={value?.id || value || index} className="specialty-tag">
                <p>{value}</p>
              </div>
            );
          })}
        </div>
      </IonContent>
    </IonModal>
  );
};


